import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeletePayrollPeriod(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deletePayrollPeriod = (payrollPeriodId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`payroll-periods/${payrollPeriodId}/`);
  };

  return useMutation(deletePayrollPeriod, {
    onSuccess: () => {
      queryClient.removeQueries({
        queryKey: ['payrollPeriods'],
      });
      queryClient.invalidateQueries({
        queryKey: ['staffsPayout'],
      });
      queryClient.invalidateQueries({
        queryKey: ['payroll'],
      });
    },
  });
}
